import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        setStep: '&',
        step: '=',
        setSummary: '&',
        summary: '=',
        update: '&'
    },
    template: `
        <div class="modal-body">
            <modals-question-import-steps step="vm.step"/>
            <div ng-if="vm.hasErrors" class="alert alert-danger">
                <p>{{ vm.rowErrorTranslation }}</p>
            </div>
            <ul ng-if="vm.hasErrors" class="items08">
                <li ng-repeat="(error, rows) in vm.groupedErrors">
                    <p class="heading">{{ error }}</p>
                    <p>{{ 'question.Affected rows:' | translate }} {{ vm.arrayToString(rows) }}</p>
                </li>
            </ul>
            <div ng-if="!vm.hasErrors && vm.confirmValidations.length" class="alert alert-notify">
                <p>{{ vm.rowNotificationTranslation }}</p>
            </div>
            <ul ng-if="!vm.hasErrors && vm.confirmValidations.length" class="items08">
                <li ng-repeat="notification in vm.groupedNotifications">
                    <p class="heading">{{ 'question.ID' | translate }}: {{ notification.externalId }}, {{ 'question.Row' | translate }}: {{ notification.rowNumber }}</p>
                    <small ng-if="vm.confirmMessages[notification.rowNumber]" ng-repeat="message in vm.confirmMessages[notification.rowNumber]" class="negative">{{ message }}</small>
                    <p ng-bind-html="historyItem" ng-repeat="historyItem in notification.history"></p>
                </li>
            </ul>
            <ul ng-if="!vm.hasErrors && vm.confirmValidations.length" class="checkboxes">
                <li>
                    <label ng-class="{'negative' : vm.errors.confirmValidations}">
                        <input ng-model="vm.isUpdateConfirmed" type="checkbox">
                        {{ 'question.I confirm that I have reviewed and want to implement all changes made to questions displayed above' | translate }}
                    </label>
                </li>
		    </ul>
        </div>
         <div class="modal-footer" >
            <ul class="actions01">
                <li ng-if="vm.hasErrors" class="primary">
                    <button class="btn main" type="button" ng-click="vm.setStep({ step: 1})">
                        {{ 'question.Start over' | translate }}
                    </button>
                </li>
                <li ng-if="!vm.hasErrors && vm.confirmValidations.length" class="primary">
                    <button class="btn main" type="button" ng-click="vm.confirmUpdate()">
                        {{ 'question.Next' | translate }}
                    </button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.update()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, QUESTIONS_CONFIRM_ENUM, QuestionResource, QuestionImportService, TokenService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.QUESTIONS_CONFIRM_ENUM = QUESTIONS_CONFIRM_ENUM;
        this.QuestionResource = QuestionResource;
        this.QuestionImportService = QuestionImportService;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.groupedErrors = {};
        this.groupedNotifications = [];
        this.errors = {};

        this.organizeErrors();
    }

    confirmUpdate () {
        this.errors.confirmValidations = false;

        if (this.isUpdateConfirmed) {
            this.QuestionResource.import({ isUpdateConfirmed: this.isUpdateConfirmed }, this.QuestionImportService.getFormattedImportData()).$promise.then((response) => {
                this.importing = false;
                this.setSummary({ summary: response });
                if (response.failed === 0) {
                    this.setStep({ step: 4 });
                }
                else {
                    this.setStep({ step: 3 });
                }
            });
        }
        else {
            this.errors.confirmValidations = true;
        }
    }

    organizeErrors () {
        this.confirmMessages = {};
        this.confirmValidations = [];
        this.hasErrors = false;

        this.lodash.forEach(this.summary.failedFormErrors, (errors, key) => {
            const rowNumber = Number(key) + 2; // rows are processed in order they were sent
            this.lodash.forEach(errors, (error, errorKey) => {
                if (errorKey === this.QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_CHANGES) {
                    this.confirmValidations.push(this.lodash.merge(error[0], { rowNumber }));

                    delete this.summary.failedFormErrors[key][errorKey];

                    if (this.lodash.isEmpty(this.summary.failedFormErrors[key])) {
                        delete this.summary.failedFormErrors[key];
                    }
                }
                else if (errorKey === this.QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_SURVEY_OR_FEEDBACK) {
                    this.confirmValidations.push(this.lodash.merge(error[0], { rowNumber }));

                    if (!this.confirmMessages[rowNumber]) {
                        this.confirmMessages[rowNumber] = [];
                    }
                    this.confirmMessages[rowNumber].push(this.QUESTIONS_CONFIRM_ENUM.LABELS.CONFIRM_HAS_SURVEY_OR_FEEDBACK);

                    delete this.summary.failedFormErrors[key][errorKey];

                    if (this.lodash.isEmpty(this.summary.failedFormErrors[key])) {
                        delete this.summary.failedFormErrors[key];
                    }
                }
                else if (errorKey === this.QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_QUIZ) {
                    this.confirmValidations.push(this.lodash.merge(error[0], { rowNumber }));

                    if (!this.confirmMessages[rowNumber]) {
                        this.confirmMessages[rowNumber] = [];
                    }
                    this.confirmMessages[rowNumber].push(this.QUESTIONS_CONFIRM_ENUM.LABELS.CONFIRM_HAS_QUIZ);
                    delete this.summary.failedFormErrors[key][errorKey];

                    if (this.lodash.isEmpty(this.summary.failedFormErrors[key])) {
                        delete this.summary.failedFormErrors[key];
                    }
                }
                else {
                    const filteredError = this.handleError(error);

                    if (!this.groupedErrors[filteredError]) {
                        this.groupedErrors[filteredError] = [];
                    }
                    this.groupedErrors[filteredError].push(rowNumber);
                }
            });
        });

        // prepare array from object
        this.summary.failedFormErrors = Object.keys(this.summary.failedFormErrors).map(key => ({ key, value: this.summary.failedFormErrors[key] }));

        this.summary.failedFormErrors = this.summary.failedFormErrors.filter(Boolean);
        const rowsWithErrors = this.summary.failedFormErrors.length;

        this.rowErrorTranslation = this.$translate.instant('question.There were {rowsWithErrors} rows with errors', { rowsWithErrors });

        if (rowsWithErrors) {
            this.hasErrors = true;
        }

        if (this.confirmValidations.length) {
            this.organizeConfirmation();
            const rowsWithNotifications = this.confirmValidations.length;
            this.rowNotificationTranslation = this.$translate.instant(
                'question.There were {rowsWithNotifications} rows that already exist in database',
                { rowsWithNotifications }
            );
        }
    }

    organizeConfirmation () {
        this.lodash.forEach(this.confirmValidations, (notifications) => {
            this.handleConfirmation(notifications);
        });
    }

    handleConfirmation (notifications) {
        const confirmationEntity = {};

        this.lodash.forOwn(notifications, (notification, key) => {
            if (key.toString() === 'rowNumber') {
                confirmationEntity.rowNumber = notification;
            }
            else {
                confirmationEntity.externalId = key;
                confirmationEntity.history = this.handleHistory(notification);
            }
        });
        this.groupedNotifications.push(confirmationEntity);
    }

    handleHistory (notification) {
        const historyArray = [];
        this.lodash.forOwn(notification, (problems, key) => {
            const changedNotificationKey = this.mapKey(key);
            this.lodash.forEach(this.mapProblems(problems), (problem) => {
                const differenceStringToShow = changedNotificationKey ? `${this.mapKey(key)} (${problem})` : problem;
                historyArray.push(differenceStringToShow);
            });
        });
        return historyArray;
    }

    mapKey (key) {
        const differencesKeyParts = key.split(':');

        if (key.startsWith('questionI18n')) {
            // Do not show translation key for default language
            if (typeof differencesKeyParts[1] !== 'undefined' && differencesKeyParts[1].toString() === this.TokenService.getCompanyLanguage().toString()) {
                return '';
            }
            return `${this.$translate.instant('question.Translation')} ${differencesKeyParts[1]}`;
        }
        else if (key.startsWith('questionAnswerTranslation')) {
            // Do not show translation key for default language
            if (typeof differencesKeyParts[2] !== 'undefined' && differencesKeyParts[2].toString() === this.TokenService.getCompanyLanguage().toString()) {
                return `${this.$translate.instant('question.Answer')} ${differencesKeyParts[1] ? differencesKeyParts[1] : ''}`;
            }
            return `${this.$translate.instant('question.Answer translation')} ${differencesKeyParts[1] ? differencesKeyParts[1] : ''} ${differencesKeyParts[2] ? differencesKeyParts[2] : ''}`;
        }
        else if (key.startsWith('questionAnswer')) {
            return `${this.$translate.instant('question.Answer')} ${differencesKeyParts[1] ? differencesKeyParts[1] : ''}`;
        }
        else if (key.startsWith('questionMeta')) {
            return `${this.$translate.instant('question.Meta field')} ${differencesKeyParts[1] ? differencesKeyParts[1] : ''}`;
        }

        return `<b>${key}</b>`;
    }

    /**
     * Problems can be a certain problem or a problem mapped by subKey
     *
     * @param problems
     * @returns {Array}
     */
    mapProblems (problems) {
        const resultArray = [];

        if (problems && problems.hasOwnProperty('before')) {
            if (!problems.before) {
                resultArray.push(`${this.$translate.instant('question.added')} "${problems.after.toString()}"`);
            }
            else if (!problems.after) {
                resultArray.push(`${this.$translate.instant('question.removed')} "${problems.before.toString()}"`);
            }
            else {
                resultArray.push(`"${problems.before.toString()}" → "${problems.after.toString()}"`);
            }
        }

        this.lodash.forOwn(problems, (problem, key) => {
            if (problem && problem.hasOwnProperty('before')) {
                if (!problem.before) {
                    resultArray.push(`<b>${key.toString()}</b>: ${this.$translate.instant('question.added')} "${problem.after.toString()}"`);
                }
                else if (!problem.after) {
                    resultArray.push(`<b>${key.toString()}</b>: ${this.$translate.instant('question.removed')} "${problem.before.toString()}"`);
                }
                else {
                    resultArray.push(`<b>${key.toString()}</b>: "${problem.before.toString()}" → "${problem.after.toString()}"`);
                }
            }
        });
        return resultArray;
    }

    // handle errors to extract message only
    handleError (error) {
        let errorMessage = null;
        this.lodash.forEach(error, (errorValue, key) => {
            if (typeof key === 'number') {
                errorMessage = errorValue;
            }
            else if (typeof key === 'string') {
                // Recursively get the value
                errorMessage = this.handleError(errorValue);
            }
        });
        if (!errorMessage) {
            // in case the upper logic does not work, just show the whole error json encoded
            errorMessage = JSON.stringify(error);
        }

        return errorMessage;
    }

    arrayToString (rows) {
        return rows.join(', ');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/errors/index.js